export type NotificationReference = {
  reference: string | null;
  createdAt: number;
};

export function canAppealReportingRestriction(
  notification: NotificationReference,
  notifications: readonly NotificationReference[],
) {
  if (!notification.reference?.startsWith("report-restriction:")) return false;
  return !notifications.some((candidate) =>
    candidate.reference?.startsWith("report-restriction-appeal:")
      && candidate.createdAt >= notification.createdAt,
  );
}
